import {IntermediatePart} from "../../intermediatePart";

export default class Stovetop extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_stovetop';
    this.partName = 'Stovetop';
    this.dbName = 'Island Stove'; // temporarily
    this.translateId = "visualizer.kitchen.center_island.center_island_stovetop";
    this.canBeDisabled = true;
    this.shouldLoadInMultipleGroups = true;
    if (isChild) {
      this.shouldLoadInMultipleGroups = true;
    }
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Stovetop());
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    if (!this.disabled && centerIslandParent.cabinet) {
      centerIslandParent.cabinet.disabled = false;
      centerIslandParent.cabinet.disabledClick();
    } else {
      const islandHood = centerIslandParent.islandHood;
      if (islandHood) {
        islandHood.disabled = this.disabled;
      }
    }
  }

}
